import prefix from './../../prefix'
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
//stateBase可用来重置;
export let stateBase = {
  menu:{
    a:1,
    b:2
  }
};

export default {
  namespaced: true,
  state:JSON.parse(JSON.stringify(stateBase)),
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/demo/index.js